<div>
    <app-page-surface-header titleIcon="user" title="Account Settings">
        <ng-container ngProjectAs="[pageHeaderActions]">
            <ul class="flex space-x-2 rtl:space-x-reverse">
                <li>
                    <a href="javascript:;" class="text-primary hover:underline">Users</a>
                </li>
                <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
                    <span>Account Settings</span>
                </li>
            </ul>
        </ng-container>
    </app-page-surface-header>
    <div class="">
        <div
            class="mb-5 flex overflow-y-auto whitespace-nowrap border-b border-[#ebedf2] font-semibold dark:border-[#191e3a]">
            <a href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
                [ngClass]="{ '!border-primary text-primary':  activeTab.toLowerCase() === 'home'}"
                (click)="activeTab = 'home'">
                <icon-home />
                Home
            </a>
            <a href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
                [ngClass]="{ '!border-primary text-primary':  activeTab.toLowerCase() === 'change-password'}"
                (click)="activeTab = 'change-password'">
                <icon-lock />
                Change Password
            </a>
        </div>
        <div>
            <div *ngIf="activeTab.toLowerCase() === 'home'"
                class="grid grid-cols-1 items-start gap-5 lg:grid-cols-10 lg:gap-6">
                <div
                    class="h-full rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726] lg:col-span-3">
                    <h6 class="mb-2 text-lg font-bold">Profile photo</h6>
                    <p class="mb-4 text-sm text-gray-500 dark:text-gray-400">
                        Upload a new picture. This updates your avatar in the header and on this page. Image only, up to
                        5 MB.
                    </p>
                    <div *ngIf="pictureError"
                        class="mb-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-800 dark:bg-red-900/30 dark:text-red-200">
                        {{ pictureError }}
                    </div>
                    <div *ngIf="pictureSuccess"
                        class="mb-3 rounded-md bg-emerald-50 px-3 py-2 text-sm text-emerald-900 dark:bg-emerald-900/30 dark:text-emerald-100">
                        {{ pictureSuccess }}
                    </div>
                    <div class="flex flex-col items-center gap-4">
                        <input #profilePicInput type="file" accept="image/*" class="sr-only"
                            (change)="onProfilePictureSelected($event)" />
                        <div class="relative mx-auto h-28 w-28 shrink-0 md:h-36 md:w-36">
                            <img [src]="avatarUrl" alt="Profile"
                                class="h-full w-full rounded-full object-cover ring-2 ring-white/10 dark:ring-white/5" />
                            <div
                                class="absolute -bottom-0.5 -right-0.5 flex gap-1 rounded-full bg-white/95 p-1 shadow-md ring-1 ring-black/5 dark:bg-[#0e1726] dark:ring-white/10">
                                <button type="button"
                                    class="flex h-9 w-9 items-center justify-center rounded-full text-primary transition hover:bg-primary/10 disabled:opacity-50"
                                    [disabled]="pictureUploading || pictureDeleting"
                                    [title]="pictureUploading ? 'Uploading…' : 'Change photo'"
                                    (click)="profilePicInput.click()">
                                    <icon-pencil class="h-4.5 w-4.5" />
                                </button>
                                <button type="button"
                                    class="flex h-9 w-9 items-center justify-center rounded-full text-red-600 transition hover:bg-red-50 disabled:opacity-40 dark:text-red-400 dark:hover:bg-red-500/10"
                                    [disabled]="!hasStoredProfilePicture || pictureUploading || pictureDeleting"
                                    [title]="hasStoredProfilePicture ? 'Remove photo' : 'No photo to remove'"
                                    (click)="removeProfilePicture()">
                                    <icon-trash class="h-4.5 w-4.5" />
                                </button>
                            </div>
                        </div>
                        <p class="text-center text-xs text-gray-500 dark:text-gray-400">
                            <span *ngIf="pictureUploading || pictureDeleting">{{ pictureDeleting ? 'Removing…' :
                                'Uploading…' }}</span>
                        </p>
                    </div>
                </div>

                <form
                    class="h-full rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726] lg:col-span-7"
                    (ngSubmit)="submitProfile($event)">
                    <h6 class="mb-2 text-lg font-bold">Profile details</h6>
                    <p class="mb-4 text-sm text-gray-500 dark:text-gray-400">Update your name, email, and phone. Save
                        this form without re-uploading your photo.</p>
                    <div *ngIf="profileGeneralError"
                        class="mb-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-800 dark:bg-red-900/30 dark:text-red-200">
                        {{ profileGeneralError }}
                    </div>
                    <div *ngIf="profileSuccess"
                        class="mb-3 rounded-md bg-emerald-50 px-3 py-2 text-sm text-emerald-900 dark:bg-emerald-900/30 dark:text-emerald-100">
                        {{ profileSuccess }}
                    </div>
                    <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
                        <div>
                            <label for="accFullName" class="mb-1.5 block">Full name <span
                                    class="text-red-500">*</span></label>
                            <input id="accFullName" name="accFullName" type="text" required [(ngModel)]="fullName"
                                (ngModelChange)="clearProfileFieldError('fullName')" [disabled]="profileSubmitting"
                                class="form-input" [ngClass]="{ 'border-red-500': profileErrors['fullName'] }"
                                autocomplete="name" />
                            <p *ngIf="profileErrors['fullName']" class="mt-1 text-xs text-red-600 dark:text-red-400">{{
                                profileErrors['fullName'] }}</p>
                        </div>
                        <div>
                            <label for="accEmail" class="mb-1.5 block">Email <span class="text-red-500">*</span></label>
                            <input id="accEmail" name="accEmail" type="email" required [(ngModel)]="emailId"
                                (ngModelChange)="clearProfileFieldError('emailId')" [disabled]="profileSubmitting"
                                class="form-input" [ngClass]="{ 'border-red-500': profileErrors['emailId'] }"
                                autocomplete="email" />
                            <p *ngIf="profileErrors['emailId']" class="mt-1 text-xs text-red-600 dark:text-red-400">{{
                                profileErrors['emailId'] }}</p>
                        </div>
                        <div class="sm:col-span-2">
                            <app-intl-phone-field label="Phone" inputId="accPhone" name="accPhone"
                                placeholder="National number" [disabled]="profileSubmitting"
                                [(countryIso)]="phoneCountryIso" [(nationalNumber)]="phoneNational"
                                (countryIsoChange)="clearProfileFieldError('mobile')"
                                (nationalNumberChange)="clearProfileFieldError('mobile')" />
                            <p *ngIf="profileErrors['mobile']" class="mt-1 text-xs text-red-600 dark:text-red-400">{{
                                profileErrors['mobile'] }}</p>
                            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Country code is saved with your
                                number. The server requires a 10-digit national number.</p>
                        </div>
                    </div>
                    <div
                        class="mt-8 flex flex-wrap justify-end gap-3 border-t border-dashed border-gray-300 pt-6 dark:border-[#191e3a]">
                        <button type="submit"
                            class="btn rounded-full bg-[#303030] px-8 font-semibold text-white shadow-lg disabled:cursor-not-allowed disabled:opacity-60"
                            [disabled]="profileSubmitting">
                            {{ profileSubmitting ? 'Saving…' : 'Save' }}
                        </button>
                    </div>
                </form>
            </div>
            <div *ngIf="activeTab.toLowerCase() === 'change-password'">
                <form
                    class="mb-5 rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]"
                    (ngSubmit)="submitChangePassword($event)">
                    <h6 class="mb-5 text-lg font-bold">Change Password</h6>
                    <p class="mb-4 text-sm text-gray-500 dark:text-gray-400">
                        Use a strong password. After a successful update you will be asked to sign in again.
                    </p>
                    <div *ngIf="passwordError"
                        class="mb-4 rounded-md bg-red-50 px-3 py-2 text-sm text-red-800 dark:bg-red-900/30 dark:text-red-200">
                        {{ passwordError }}
                    </div>
                    <div *ngIf="passwordSuccess"
                        class="mb-4 rounded-md bg-emerald-50 px-3 py-2 text-sm text-emerald-900 dark:bg-emerald-900/30 dark:text-emerald-100">
                        {{ passwordSuccess }}
                    </div>
                    <div class="grid grid-cols-1 gap-5 sm:grid-cols-1">
                        <div class="w-full">
                            <label for="currentPassword">Current Password</label>
                            <input id="currentPassword" name="currentPassword" type="password"
                                autocomplete="current-password" [(ngModel)]="currentPassword"
                                [disabled]="passwordSubmitting" class="form-input" />
                        </div>
                        <div class="w-full">
                            <label for="newPassword">New Password</label>
                            <input id="newPassword" name="newPassword" type="password" autocomplete="new-password"
                                [(ngModel)]="newPassword" [disabled]="passwordSubmitting" class="form-input" />
                        </div>
                        <div class="w-full">
                            <label for="confirmPassword">Confirm Password</label>
                            <input id="confirmPassword" name="confirmPassword" type="password"
                                autocomplete="new-password" [(ngModel)]="confirmPassword"
                                [disabled]="passwordSubmitting" class="form-input" />
                        </div>
                    </div>
                    <div
                        class="mt-8 flex flex-wrap justify-end gap-3 border-t border-dashed border-gray-300 pt-6 dark:border-[#191e3a]">
                        <button type="submit"
                            class="btn rounded-full bg-[#303030] px-8 font-semibold text-white shadow-lg disabled:cursor-not-allowed disabled:opacity-60"
                            [disabled]="passwordSubmitting">
                            {{ passwordSubmitting ? 'Saving…' : 'Save' }}
                        </button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>